
$(function() {
  $(document).on("click", ".add_to_cart", function () {
    setTimeout(function(){
      updateCartCountCookie();
    }, 500);
  });
});

var _learnq = _learnq || [];
var classname = document.getElementsByClassName("addOrder");
var addToCart = function() {
_learnq.push(['track', 'Added to Cart', item]);
};
for (var i = 0; i < classname.length; i++) {
classname[i].addEventListener('click', addToCart, false);
}

$(function() {
  $(window).on('scroll resize', function() {
    let isAnyAddListVisible = false;
    $('.addList,.embla').each(function() {
      let elementTop = $(this).offset().top;
      let elementBottom = elementTop + $(this).outerHeight();
      let viewportTop = $(window).scrollTop();
      let viewportBottom = viewportTop + $(window).height();
      if (elementBottom > viewportTop && elementTop < viewportBottom) {
        isAnyAddListVisible = true;
        return false;
      }
    });
    if (isAnyAddListVisible) {
      if ($('.addFloat').is(':visible')) {
        $('.addFloat').fadeOut(300);
      }
    } else {
      if (!$('.addFloat').is(':visible')) {
        $('.addFloat').fadeIn(300);
      }
    }
  });
  $(window).trigger('scroll');
});

$(function () {
    if ($("#spec").length > 0) {
        var productSpecContent = $("#spec").clone().prop("outerHTML");
        $("body").append(`
            <div id="productSpecModal" class="modal micromodal-slide" aria-hidden="true">
                <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                    <div class="modal__container" role="dialog" aria-modal="true">
                        <button class="modal__close" aria-label="Close modal" data-micromodal-close>&times;</button>
                        <div class="modal__content__container">
                            <div class="modal__content resImg">${productSpecContent}</div>
                        </div>
                    </div>
                </div>
            </div>
        `);
        $('.addList').before('<button class="checkSizeBtn mini arrow_right R mr0" data-micromodal-trigger="productSpecModal">サイズや注意点を確認する</button>');
        MicroModal.init();
        function resetModalScroll() {
            $(".modal__content__container").scrollTop(0);
        }
        $(".checkSizeBtn").on("click", function (e) {
            MicroModal.show("productSpecModal");
            //setTimeout(resetModalScroll, 100);
        });
    }

    if ($("#customer_review").length > 0) {
        var reviewButton = '<button class="reviewBtn mini arrow_right">お客様レビューを見る</button>';
        if ($('.checkSizeBtn').length > 0) {
            $('.checkSizeBtn').after(reviewButton);
        } else {
            $('.addList').before(reviewButton);
        }
        $(document).on("click", ".reviewBtn", function (e) {
            e.preventDefault();
            var target = $("#customer_review").offset().top;
            $("html, body").animate({ scrollTop: target }, 500, "easeOutExpo");
        });
    }
});

$(function () {
    var $reviews = $(".review");
    var $reviewContainer = $reviews.parent();
    
    if ($reviews.length <= 1) {
        return; // .reviewが1件のみの場合は何もしない
    }
    
    var randomIndex = Math.floor(Math.random() * $reviews.length);
    var $selectedReview = $reviews.eq(randomIndex);
    var $hiddenReviews = $("<div>").css("display", "none");
    
    $reviews.not($selectedReview).appendTo($hiddenReviews);
    $reviewContainer.append($hiddenReviews);
    
    var hiddenCount = $reviews.not($selectedReview).length;
    var $showMoreBtn = $('<button>' + hiddenCount + '件のレビューをすべて見る</button>').css({
        display: 'block',
        margin: '2rem auto',
        padding: '1rem 2rem',
        cursor: 'pointer',
        border: '1px #000 solid',
        backgroundColor: '#C64A36',
        color: '#fff',
        borderRadius: '1rem'
    });
    
    $reviewContainer.append($showMoreBtn);
    
    $showMoreBtn.on("click", function () {
        $hiddenReviews.slideDown(400, "swing");
        $showMoreBtn.fadeOut();
    });
});


